export default __webpack_public_path__ + "static/media/whatsapp_logo.58ef144f.png";